import { render } from "./FatButtonFloat.vue?vue&type=template&id=40fc9d9b&scoped=true&ts=true"
import script from "./FatButtonFloat.vue?vue&type=script&lang=ts"
export * from "./FatButtonFloat.vue?vue&type=script&lang=ts"

import "./FatButtonFloat.vue?vue&type=style&index=0&id=40fc9d9b&scoped=true&lang=css"

import exportComponent from "/home/bese/Documents/partybeast/party-beast-prototype/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40fc9d9b"]])

export default __exports__